module.exports = __webpack_public_path__ + "dist/img/ibank-logo.1c4e1723.png";